import React, { FC } from "react";
type Props = {};
export const NotFound: FC<Props> = () => {
  return <>NotFound 404</>;
};
